import { render, staticRenderFns } from "./ManifestAttach.vue?vue&type=template&id=6329155a&scoped=true&"
import script from "./ManifestAttach.vue?vue&type=script&lang=js&"
export * from "./ManifestAttach.vue?vue&type=script&lang=js&"
import style0 from "./ManifestAttach.vue?vue&type=style&index=0&id=6329155a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6329155a",
  null
  
)

export default component.exports